import React, { Component, Fragment } from 'react';
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import { numberFormat } from '../../common';

@withRouter
@inject('totoStore', 'dictStore')
@observer
export default class BetContainer extends Component{

  componentDidMount() {
    this.props.totoStore.Bet.init(this.props.match.params.betId);
  }

  render() {
    const {isLoading, result, Bet} = this.props.totoStore;
    const {getLang} = this.props.dictStore;
    return(
      !isLoading ? 
        <div className="toto-index-loading">
          <LoadingSpinner />
        </div> :
      <Fragment>
        {Bet.data ? <TotoBet /> : <div className="toto-index-no">{getLang('INVALID_CARD_ID')}</div>}
      </Fragment>
    )
  }
}

@inject('totoStore', 'dictStore', 'appStore')
@observer
class TotoBet extends Component { 

  selectCurrency = (e) => {
    this.props.totoStore.selectCurrency(e.target.value)
  }

  goBack = () => {
    this.props.appStore.history.goBack();
  }

	render() {

    const {getLang} = this.props.dictStore;
    const {currency, currencyId, current} = this.props.totoStore;
    const {data} = this.props.totoStore.Bet;
    const {cashboxMode} = this.props.appStore;
    let number = 0;
    const options = ['1', 'X', '2'];

			return(
				<div className="toto-bet">
          <h1 className="hidden">{getLang('TOTO_CARD')}</h1>
          <div className="clearfix">
            <div className="fl_r">
              <label htmlFor="toto-currency">{getLang('SHOW_IN_CURRENCY')} </label>
              <select className="toto-index-currency" onChange={this.selectCurrency}>
                {Object.keys(data.currency).map(id => 
                  <option key={id} value={data.currency[id].id} selected={data.currency[id].id == currencyId}>{data.currency[id].full_name}</option>
                )}
              </select>
            </div>
            <div className="toto-bet-back">
              <a className="back" onClick={this.goBack}>Назад</a>
            </div>
          </div>
          <div className="toto-bet-header clearfix">
            {data.pool.length ? 
              <div className="toto-bet-pool-cont">
                <table className="toto-table">
                  <thead>
                  <tr>
                    <th>{getLang('GUESSED_RESULT')}</th>
                    <th>{getLang('BET_COUNT')}</th>
                    <th>{getLang('AMOUNT')}</th>
                  </tr>
                  </thead>
                  <tbody>
                    {data.pool.map( el =>                           
                      <tr key={el.guessed}>
                        <td className="toto-table-guessed">{el.guessed}</td>
                        <td className="toto-table-count">{el.count}</td>
                        <td className="toto-bet-table-amount">
                          <span>
                            {numberFormat(el.amount[currencyId], 2, ',', ' ')}
                          </span>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            : ''}
            <div className="toto-bet-data">
              <div className="toto-bet-row clearfix">
                <div className="toto-bet-row-label fl_l">{cashboxMode === 2 ? getLang('COUPON_FOR_SUPER_EXPRESS') : getLang('COUPON_FOR_TOTO')} №</div>
                <div className="toto-bet-row-data">{data.code}</div>
              </div>
              <div className="toto-bet-row clearfix">
                <div className="toto-bet-row-label fl_l">{getLang('RECEPTION_TIME')}</div>
                <div className="toto-bet-row-data">{data.date}</div>
              </div>
              <div className="toto-bet-row clearfix">
                <div className="toto-bet-row-label fl_l">{getLang('BET_COUNT')}</div>
                <div className="toto-bet-row-data">{data.bet_count}</div>
              </div>
              {data.status != 1 ?
                <div className="toto-bet-row clearfix">
                  <div className="toto-bet-row-label fl_l">{getLang('MAX_GUESSED_RESULTS')}</div>
                  <div className="toto-bet-row-data">{data.option_guessed}</div>
                </div>
              : ''}
              <div className="toto-bet-row clearfix">
                <div className="toto-bet-row-label fl_l">{getLang('AMOUNT')}</div>
                <div className="toto-bet-row-data">
                  <span>{numberFormat(data.amount.set[currencyId], 2, ',', ' ')} {current.name}</span>
                </div>
              </div>
              {data.status == 1 ?
                <div className="toto-bet-row clearfix">
                  <div className="toto-bet-row-label fl_l"></div>
                  <div className="toto-bet-row-data">{getLang('RESULT_EXPECTED')}</div>
                </div>
              : 
                 <div className="toto-bet-row clearfix">
                    <div className="toto-bet-row-label fl_l">{getLang('PAYOUT')}</div>
                    <div className="toto-bet-row-data">
                        <span>{numberFormat(data.amount.win[currencyId], 2, ',', ' ')} {current.name}</span>
                    </div>
                </div>
              }
            </div>
          </div>
          <div className="toto-bet-table-cont">
            <table className="toto-table">
              <thead>
                <tr>
                  <th>№</th>
                  <th>{getLang('DATE')}</th>
                  <th colSpan="2">{getLang('EVENT')}</th>
                  <th colSpan="3">{getLang('OUTCOME')}</th>
                  <th>{getLang('RESULT')}</th>
                </tr>
              </thead>
              <tbody>
                { Object.keys(data.sport).map(sid => {
                  const league = data.sport[sid].league;
                  return (
                    league.map(lid => 
                      <Fragment key={`tr_${lid}`}>
                        <tr>
                          <td className="toto-table-league-name" colSpan="10">{data.dict.sport[sid]}. {data.dict.league[lid]}</td>
                        </tr>
                        {data.league[lid].games.map((gid, idx) => {
                          ++number;
                          return(
                            <tr className="toto-index-game"  key={`td_${gid}`}>
                              <td className="toto-table-id">{number}</td>
                              <td className="toto-table-date">{data.games[gid].date}</td>
                              <td className="toto-table-cmd">{data.dict.cmd[data.games[gid].c1_id]}</td>
                              <td className="toto-table-cmd">{data.dict.cmd[data.games[gid].c2_id]}</td>
                              {options.map(el => 
                                <td key={el} className={`toto-table-option${ data.status != 1 && data.games[gid].option[el].b ? (data.games[gid].option[el].g ? ' toto-table-option-guessed' : ' toto-table-option-not-guessed') : ''}`} >{data.games[gid].option[el].b ? el : ''}</td>
                              )}
                              <td className="toto-table-score">
                                {data.games[gid].status === 2
                                ? getLang('CALCELLED')
                                : data.games[gid].status === 1
                                ? data.games[gid].score != '{{ NO }}'
                                  ? data.games[gid].score
                                  : ''
                                : getLang('NO')}
                              </td>
                            </tr>
                         )
                        })}
                      </Fragment>
                  )
                )}
              )}
              </tbody>
            </table>
          </div>
        </div>
			)
	}
}


// WEBPACK FOOTER //
// ./src/components/toto/bet.jsx